import compose from 'lodash/flowRight'
import { useSelector } from 'react-redux'
import styled from 'styled-components'

import { isLiteRetailer, isProRetailer } from 'store/currentUser/selectors'

import CreateOrderTemplateModal from 'modals/OrderList/CreateOrderTemplateModal'
import ExcelOrdersModal from 'modals/OrderList/ExcelOrdersModal'
import ExcelSummaryModal from 'modals/OrderList/ExcelSummaryModal'
import { ORDER_LIST, VISUAL_ASSORTMENT } from 'routes/paths'

import DropdownMenuGroup from '../DropdownMenuGroup/DropdownMenuGroup'
import DropdownMenuTextLink from '../DropdownMenuTextLink/DropdownMenuTextLink'
import NavbarDropdown from '../NavbarDropdown/NavbarDropdown'
import { NavbarOrdersMenu } from '../OrdersDropdown/NavbarOrdersOrdersMenu'
import Trigger from '../Trigger/Trigger'
import withModal from 'containers/ModalHandler/ModalHandler.component'
import { useResetAllFilters } from 'containers/OrderListFilters/OrderListFilters.hooks'
import messages from 'features/Navbar/NavbarRevamp/constants/navbarRevamp.messages'
import { OrdersDropdownIds } from 'features/Navbar/NavbarRevamp/navbarRevamp.ids'
import {
  INavbarOrdersDropdown,
  IOrdersDropdownSelectors,
} from 'features/Navbar/NavbarRevamp/navbarRevamp.types'

const NavbarOrdersDropdownContainer = styled.div`
  display: flex;
`

const NavbarOrdersDropdown = ({ openDynamicModal }: INavbarOrdersDropdown) => {
  const { isLiteRetailerAccount, isProRetailerAccount } = useSelector<
    object,
    IOrdersDropdownSelectors
  >((state) => ({
    isLiteRetailerAccount: isLiteRetailer(state),
    isProRetailerAccount: isProRetailer(state),
  }))
  const resetOrderListFilters = useResetAllFilters()

  const openExcelSummaryModal = () => {
    openDynamicModal({
      component: ExcelSummaryModal,
      openExcelOrdersModal: openExcelOrdersModal,
    })
  }

  const openCreateOrderTemplateModal = () => {
    openDynamicModal({
      component: CreateOrderTemplateModal,
      openExcelOrdersModal: openExcelOrdersModal,
    })
  }

  const openExcelOrdersModal = () => {
    openDynamicModal({
      component: ExcelOrdersModal,
      openCreateOrderTemplateModal: openCreateOrderTemplateModal,
      openExcelSummaryModal: openExcelSummaryModal,
    })
  }

  if (isProRetailerAccount) {
    return null
  }

  if (isLiteRetailerAccount) {
    return (
      <NavbarOrdersDropdownContainer>
        <NavbarDropdown
          trigger={
            <Trigger
              label={messages.ordersAndVisualAssortment}
              id={OrdersDropdownIds.OrdersAndVisualAssortmentTrigger}
            />
          }
        >
          <DropdownMenuGroup>
            <DropdownMenuTextLink
              to={ORDER_LIST}
              message={messages.manageOrders}
              id={OrdersDropdownIds.OrdersOptionOrders}
              onClick={resetOrderListFilters}
            />
            <DropdownMenuTextLink
              to={VISUAL_ASSORTMENT}
              message={messages.visualAssortment}
              id={OrdersDropdownIds.OrdersOptionVisualAssortment}
            />
          </DropdownMenuGroup>
        </NavbarDropdown>
      </NavbarOrdersDropdownContainer>
    )
  }

  return (
    <NavbarOrdersDropdownContainer>
      <NavbarDropdown
        trigger={
          <Trigger
            label={messages.orders}
            id={OrdersDropdownIds.OrdersTrigger}
          />
        }
      >
        {<NavbarOrdersMenu openDynamicModal={openDynamicModal} />}
      </NavbarDropdown>
    </NavbarOrdersDropdownContainer>
  )
}

export default compose(withModal)(NavbarOrdersDropdown)
